import axios from "axios";
import { useRef, useState } from "react";
import './Student.css'
import Progress from "../Progress/Progress";
const Student = (props) => {
  const [ren, setRen] = useState(false);
  const [detail, setDetail] = useState({});
  const delState = props.delState;
  const setDelState = props.setDelState;
  const See_details = (id) => {
    axios
      .get(`https://66ed69c7380821644cdcbca5.mockapi.io/todolist/${id}`)
      .then((success) => {
        setDetail(success.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const deleteData = (id) => {
    axios
      .delete(`https://66ed69c7380821644cdcbca5.mockapi.io/todolist/${id}`)
      .then((success) => {
        alert("data deleted successfully...!");
        setDelState(!delState);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  var elm = useRef();
  if (ren) {
    if (detail.Marks <= 30) {
      elm.current.style.backgroundColor = "rgb(255, 53, 53)";
      elm.current.style.width = `${detail.Marks}%`;
      console.log(detail.Marks);
      console.log(elm.current.style);
    } else if (detail.Marks > 30 && detail.Marks <= 45) {
      elm.current.style.backgroundColor = "rgb(265,165,0)";
      elm.current.style.width = `${detail.Marks}%`;
    } else if (detail.Marks > 45 && detail.Marks <= 70) {
      elm.current.style.backgroundColor = "yellow";
      elm.current.style.width = `${detail.Marks}%`;
    } else if (detail.Marks > 70 && detail.Marks < 85) {
      elm.current.style.backgroundColor = "rgb(65, 216, 65)";
      elm.current.style.width = `${detail.Marks}%`;
    } else {
      elm.current.style.backgroundColor = "rgb(12, 178, 12)";
      elm.current.style.width = `${detail.Marks}%`;
    }
  }

  return (
    <div className="container pb-5">
      <div className="row">
        <div className="col-lg-6 mb-4">
          <div className="list"> 
              <div className="list-heading">
                <p className="col-4 col-sm-3">FirstName</p>
                <p className="col-4 col-sm-3">LastName</p>
                <p className="col-4 col-sm-6">Buttons</p>
              </div>
              {props.mydata.map((x) => {
                return (
                  <div key={x.Id} className="list-item">
                    <p className="col-4 col-sm-3">{x.FirstName}</p>
                    <p className="col-4 col-sm-3">{x.LastName}</p>
                    <p className="col-4 col-sm-6">
                      <button
                        className="btn btn-primary me-2"
                        onClick={() => {
                          See_details(x.Id);
                        }}
                      >
                        See Details
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={() => {
                          deleteData(x.Id);
                        }}
                      >
                        Delete
                      </button>
                    </p>
                  </div>
                );
              })}
          </div>
        </div>
        <div className="col-lg-6 mb-4">
        {!isNaN(detail.Id) && (
          <Progress detail={detail} elm={elm} setRen={setRen} ren={ren} />
        )}
        </div>
      </div>
    </div>
  );
};
export default Student;
